import React, { useContext, useCallback, MouseEvent, forwardRef } from "react";
import { useHistory } from "react-router";

import { IButtonProps } from "@plex/react-components/dist/esm/components/ActionBar/ActionBar.Button";
import * as log from "loglevel";

import { ActionBar } from "@plex/react-components";

import { IDialogRouteProps, DialogNavigationContext } from "./dialog";

export interface IDialogRoutableProps {
  openInDialog?: boolean;
  dialog?: IDialogRouteProps;
}

export const ActionBarLink = forwardRef<HTMLLIElement, IButtonProps & IDialogRoutableProps>(({ ...props }, ref) => {
  const history = useHistory();
  const dialogNavigationContext = useContext(DialogNavigationContext);

  const buttonProps: IButtonProps = {
    disabled: props.disabled,
    className: props.className,
    href: props.href,
    id: props.id,
    style: props.style,
    text: props.text,
    title: props.title
  };

  const clickHandler = useCallback(
    (routeData: { pathname: string; dialog?: IDialogRouteProps; openInDialog?: boolean }) => (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();

      let dialogRoute: IDialogRouteProps | undefined;

      if (routeData.openInDialog && routeData.pathname) {
        dialogRoute = {
          to: {
            location: routeData.pathname
          }
        };
      } else if (routeData.dialog) {
        dialogRoute = routeData.dialog;
      }

      if (dialogRoute) {
        dialogNavigationContext.showDialog(dialogRoute);
      } else {
        history.push(routeData.pathname);
      }
    },
    [history, dialogNavigationContext]
  );

  if (!props.href && !props.dialog) {
    log.warn("The button does not contains any route data so it will perform navigation to root route. You must set up either href or dialog property.");
  }

  return (
    <ActionBar.Button
      {...buttonProps}
      ref={ref}
      onClick={clickHandler({
        pathname: props.href ? props.href : "",
        dialog: props.dialog,
        openInDialog: props.openInDialog
      })}
    />
  );
});

ActionBarLink.displayName = "ActionBarLink";
